import { Component, OnInit } from '@angular/core';
import { Specialisation } from 'projects/qcloud-models/grafik/specialisation/specialisation.model';
import { SpecialisationService } from 'projects/qcloud-rest-client/src/lib/grafik/specialisation.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { RouteNavigationService } from 'projects/qcloud-web/src/app/shared/route-navigation.service';
import { ChangesTrackerService } from 'projects/qcloud-web/src/app/shared/changes-tracker.service';

@Component({
  selector: 'app-specialities',
  templateUrl: './specialities.component.html',
  styleUrls: ['./specialities.component.css']
})
export class SpecialitiesComponent implements OnInit {

  specialities: Specialisation[];
  selectedSpecialityId: number;

  constructor(private specialityService: SpecialisationService, private translate: TranslateService,
    private toastr: ToastrService, public router: RouteNavigationService, private changesTracker: ChangesTrackerService) { }

  ngOnInit(): void {
    this.getSpecialities();
  }

  getSpecialities() {
    this.specialityService.getSpecialities((specialities) => {
      this.specialities = specialities;
      var change;
      if (this.changesTracker.getChangedEntityType() == "specialisation") {
        change = this.changesTracker.getChangedEntity("specialisation");
      }
      this.specialities.forEach(x => {
        if (change && change.id == x.id.toString()) {
          x.isChanged = true;
          this.changesTracker.navigateToChangedEntity(document);
        }
      });
    }, () => { })
  }

  onDeleteConfirm(confirmed: boolean) {
    if (confirmed) {
      this.deleteSpeciality(this.selectedSpecialityId);
    }
  }

  deleteSpeciality(specialityId: number) {
    this.specialityService.deleteSpeciality(specialityId).subscribe(
      res => {
        this.getSpecialities();
      },
      err => {
        this.translate.get('delete-error').subscribe((error: string) => {
          this.translate.get('repeat').subscribe((res: string) => {
            this.toastr.error(res, error);
          });
        });
      }
    );
  }
}
